import axios from "axios"
import {useState} from "react";

export const string10000ToMoney = (string) => {
    const k = string.split(".")
    return parseInt(k[0]) * 1000000 + parseInt((k[1] || '').slice(0, 6).padEnd(6, '0'))
}

export const money10000ToString = (money) => {
    const regexp = /(?:\.0*|(\.\d+?)0+)$/
    return (parseInt(money / 1000000).toString() + '.' + money.toString().slice(-6)).replace(regexp, '$1')
}

const serverURL = "https://service-i52oqtnr-1259725782.sh.apigw.tencentcs.com/release/"

let uploadList = []

export const uploadFile = async () => {
    document.getElementById("fileElem").click()
    const p = new Promise((resolve, reject) => {
        uploadList.push(resolve)
    });
    return p
}


const getUploadURL = async (extension) => {
    let that = this
    const response = await axios.post(serverURL, {
        extension
    }, {
        headers: {
            Authorization: localStorage.getItem('token')
        }
    })
    console.log(response.data.data)
    if (!!response.data.fileName && !!response.data.url) {
        return response.data
    }
}

const inputElement = document.getElementById("fileElem");
inputElement.addEventListener("change", handleFiles, false);

function uploaded(fileName, name) {
    uploadList.pop()(fileName, name)
}

function handleFiles(e) {
    if (this.files.length == 0) return;
    let fileReader = new FileReader();
    let dataFile = this.files[0];
    const _this = this
    fileReader.readAsBinaryString(dataFile);
    //enqueueSnackbar('正在上传附件...');
    fileReader.onload = async function (e) {
        let extension = _this.files[0]['name'].split('.').pop().toLowerCase()
        getUploadURL(extension).then(({url, fileName}) => {
            console.log(url)
            axios.put(url, dataFile, {
                headers: {
                    'Content-Type': dataFile.type
                }
            }).then(() => {
                uploaded({fileName, name: _this.files[0]['name']})
            })
        })

    };
}

export function useLocalStorage(key, initialValue) {
    // State to store our value
    // Pass initial state function to useState so logic is only executed once
    const [storedValue, setStoredValue] = useState(() => {
        if (typeof window === "undefined") {
            return initialValue;
        }
        try {
            // Get from local storage by key
            const item = window.localStorage.getItem(key);
            // Parse stored json or if none return initialValue
            return item ? JSON.parse(item) : initialValue;
        } catch (error) {
            // If error also return initialValue
            console.log(error);
            window.localStorage.removeItem(key);
            window.location.reload();
            return initialValue;
        }
    });
    // Return a wrapped version of useState's setter function that ...
    // ... persists the new value to localStorage.
    const setValue = (value) => {
        try {
            // Allow value to be a function so we have same API as useState
            const valueToStore =
                value instanceof Function ? value(storedValue) : value;
            // Save state
            setStoredValue(valueToStore);
            // Save to local storage
            if (typeof window !== "undefined") {
                window.localStorage.setItem(key, JSON.stringify(valueToStore));
            }
        } catch (error) {
            // A more advanced implementation would handle the error case
            console.log(error);
        }
    };
    return [storedValue, setValue];
}
